var _regeneratorRuntime = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var Promise = require('bluebird'),
    _require = require('./ack'),
    waitOnFactoidTransactionAck = _require.waitOnFactoidTransactionAck,
    _require2 = require('./addresses'),
    isValidPublicFctAddress = _require2.isValidPublicFctAddress,
    isValidPublicEcAddress = _require2.isValidPublicEcAddress,
    _require3 = require('./transaction'),
    Transaction = _require3.Transaction,
    _require4 = require('./get'),
    getEntryCreditRate = _require4.getEntryCreditRate;

var MAX_OVERPAYING_FACTOR = 10;

function sendTransaction(_x, _x2, _x3) {
  return _sendTransaction.apply(this, arguments);
}

function _sendTransaction() {
  _sendTransaction = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(factomd, transaction, opts) {
    var options, ackTimeout, txId;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = opts || {};
            ackTimeout = options.timeout || 60;
            _context.next = 4;
            return submitTransaction(factomd, transaction, !!options.force);

          case 4:
            txId = _context.sent;

            if (!(ackTimeout >= 0)) {
              _context.next = 8;
              break;
            }

            _context.next = 8;
            return waitOnFactoidTransactionAck(factomd, txId, ackTimeout);

          case 8:
            return _context.abrupt("return", txId);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _sendTransaction.apply(this, arguments);
}

function submitTransaction(_x4, _x5, _x6) {
  return _submitTransaction.apply(this, arguments);
}

function _submitTransaction() {
  _submitTransaction = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(factomd, transaction, force) {
    var ecRate, minimumRequiresFees;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (transaction instanceof Transaction) {
              _context2.next = 2;
              break;
            }

            throw new Error('Argument must be an instance of Transaction');

          case 2:
            if (transaction.isSigned()) {
              _context2.next = 4;
              break;
            }

            throw new Error('Cannot submit an unsigned transaction');

          case 4:
            _context2.next = 6;
            return getEntryCreditRate(factomd);

          case 6:
            ecRate = _context2.sent;
            minimumRequiresFees = transaction.computeRequiredFees(ecRate);

            if (!(minimumRequiresFees > transaction.feesPaid)) {
              _context2.next = 12;
              break;
            }

            throw new Error("Insufficient fees for the transaction (paid: ".concat(transaction.feesPaid, ", minimum required: ").concat(minimumRequiresFees, ", current EC rate: ").concat(ecRate, ")"));

          case 12:
            if (!(!force && minimumRequiresFees * MAX_OVERPAYING_FACTOR < transaction.feesPaid)) {
              _context2.next = 14;
              break;
            }

            throw new Error("Transaction is overpaying required fees by more than 10 times (paid: ".concat(transaction.feesPaid, ", minimum required: ").concat(minimumRequiresFees, ", current EC rate: ").concat(ecRate, ")"));

          case 14:
            if (!force) {
              transaction.entryCreditOutputs.forEach(function (eco) {
                if (eco.amount < ecRate) {
                  throw new Error("Entry Credit output to ".concat(eco.address, " is not sufficient to get a minimum of 1 Entry Credit (").concat(eco.amount, " < ").concat(ecRate, ")."));
                }
              });
            }

            _context2.next = 17;
            return Promise.each(transaction.inputs, function (input) {
              return validateFunds(factomd, input.address, input.amount);
            });

          case 17:
            return _context2.abrupt("return", factomd.call('factoid-submit', {
              transaction: transaction.marshalBinary().toString('hex')
            }).then(function (r) {
              return r.txid;
            }));

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _submitTransaction.apply(this, arguments);
}

function validateFunds(_x7, _x8, _x9) {
  return _validateFunds.apply(this, arguments);
}

function _validateFunds() {
  _validateFunds = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(factomd, publicFctAddress, amount) {
    var _ref, balance;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return factomd.call('factoid-balance', {
              address: publicFctAddress
            });

          case 2:
            _ref = _context3.sent;
            balance = _ref.balance;

            if (!(balance < amount)) {
              _context3.next = 6;
              break;
            }

            throw new Error("Address ".concat(publicFctAddress, " doesn't have sufficient funds (balance: ").concat(balance, ")"));

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _validateFunds.apply(this, arguments);
}

function createFactoidTransaction(_x10, _x11, _x12, _x13, _x14) {
  return _createFactoidTransaction.apply(this, arguments);
}

function _createFactoidTransaction() {
  _createFactoidTransaction = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(factomd, originPrivateAddress, recipientAddress, amount, fees) {
    var ecRate;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (isValidPublicFctAddress(recipientAddress)) {
              _context4.next = 2;
              break;
            }

            throw new Error("Recipient address [".concat(recipientAddress, "] is not a valid public Factoid address"));

          case 2:
            _context4.next = 4;
            return getEntryCreditRate(factomd);

          case 4:
            ecRate = _context4.sent;
            return _context4.abrupt("return", buildTransactionWithFees(originPrivateAddress, recipientAddress, amount, ecRate, fees));

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _createFactoidTransaction.apply(this, arguments);
}

function createEntryCreditPurchaseTransaction(_x15, _x16, _x17, _x18, _x19) {
  return _createEntryCreditPurchaseTransaction.apply(this, arguments);
}

function _createEntryCreditPurchaseTransaction() {
  _createEntryCreditPurchaseTransaction = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(factomd, originPrivateAddress, recipientAddress, ecAmount, fees) {
    var ecRate, amount;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (isValidPublicEcAddress(recipientAddress)) {
              _context5.next = 2;
              break;
            }

            throw new Error("Recipient address [".concat(recipientAddress, "] is not a valid public Entry Credit address"));

          case 2:
            _context5.next = 4;
            return getEntryCreditRate(factomd);

          case 4:
            ecRate = _context5.sent;
            amount = ecAmount * ecRate;
            return _context5.abrupt("return", buildTransactionWithFees(originPrivateAddress, recipientAddress, amount, ecRate, fees));

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _createEntryCreditPurchaseTransaction.apply(this, arguments);
}

function buildTransactionWithFees(originPrivateAddress, recipientAddress, amount, ecRate, fees) {
  var requiredFees = Transaction.builder().input(originPrivateAddress, amount).output(recipientAddress, amount).build().computeRequiredFees(ecRate);
  var finalFees = requiredFees;

  if (fees && fees < requiredFees) {
    throw new Error("Cannot set fees to ".concat(fees, " factoshis because the minimum required fees are ").concat(requiredFees));
  } else if (fees) {
    finalFees = fees;
  }

  var transaction = Transaction.builder().input(originPrivateAddress, amount + finalFees).output(recipientAddress, amount).build();
  return transaction;
}

module.exports = {
  sendTransaction: sendTransaction,
  createFactoidTransaction: createFactoidTransaction,
  createEntryCreditPurchaseTransaction: createEntryCreditPurchaseTransaction
};